// extracted by mini-css-extract-plugin
module.exports = {"link":"stylesAuthNav_link__ybCF4","activeLink":"stylesAuthNav_activeLink__3c1W3"};